import React, { useEffect, useRef, useState } from "react";
import "./Proposal.css";
import apiClient, { getEditorUploadConfig } from '../../services/apiClient';
import { Link, useParams } from "react-router-dom";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import allPlugins from "../../utils/suneditorPlugins";
import TextEditorToSection from "../Create-Contract/TextEditorToSection";
import CreatePayContent from "./CreatePayContent";
import { useDispatch, useSelector } from "react-redux";
import { setTitle } from "../../redux/titleSlice";
import CommonDropdownMenuThree from "../Shared/CommonDropdownMenuThree";
import CommonDropdownMenufour from "../Shared/CommonDropdownMenufour";
import "../CreateInvoice/CreateInvoice.css";
import UnitOption from "./UnitOption";
import Swal from "sweetalert2";
import { getErrorMessage } from "../../services/errorHelper";
import SendToCustomerInfoModal from "./SendToCustomerInfoModal";
import { useNavigate } from "react-router-dom/dist/umd/react-router-dom.development";

export default React.memo(function SendProposal() {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  const [formData, setFormData] = useState({
    mainLogo: "",
    secondaryLogo: "",
    defaultHeaderImage: "",
  });

  const [phone, setPhone] = useState();
  const [companyemail, setCompanyemail] = useState();

  const [invoicenumber, setinvoicenumber] = useState(
    Math.floor(100000 + Math.random() * 900000)
  );

  const { eventID, proposalId } = useParams();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const title = useSelector((state) => state.title.title);

  const options = ["Custom Date", "Smart date"];
  const options_sub = [
    "Payment is due on a fixed calendar date",
    "Payment due date is based on event or invoice date",
  ];
  const options2 = ["day(s)", "Week(s)", "month(s)"];
  const options3 = ["before event date", "after event date"];

  const editorRef = useRef(null);
  const childStateRef = useRef();
  const [showDueDateBox, setShowDueDateBox] = useState(null);
  const [showTaxBox, setShowTaxBox] = useState(false);
  const [showDiscountBox, setShowDiscountBox] = useState(false);

  const [subtotalprice, setsubtotalprice] = useState(0);
  const [totalprice, settotalprice] = useState(0);
  const [tax, settax] = useState(0);
  const [taxval, settaxval] = useState(0);
  const [taxper, settaxper] = useState(false);
  const [discount, setdiscount] = useState(0);
  const [discountval, setdiscountval] = useState(0);
  const [discountper, setdiscountper] = useState(false);

  const [smartdate, setsmartdate] = useState(false);
  const [smartday, setsmartday] = useState("");
  const [smartmonth, setsmartmonth] = useState(false);
  const [smartyear, setsmartyear] = useState("before event date");

  const [contractadded, setcontractadded] = useState(false);
  const [invoiceadded, setinvoiceadded] = useState(false);

  const [fname, setFname] = useState();
  const [lname, setLname] = useState();
  const [companyname, setcompanyname] = useState();
  const [email, setemail] = useState();

  const [EventData, setEventData] = useState({});

  const [usersignature, setUsersignature] = useState("");
  const [signaturebox, setsignaturebox] = useState("");

  const [isChecked, setIsChecked] = useState(false);

  const [payments, setPayments] = useState([
    {
      amount: totalprice,
      dueDate: new Date().toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      }),
      paymentId: "Due Today",
      type: "",
      smartdays: '',
    },
  ]);

  const addsignature = () => {
    setUsersignature(signaturebox);
  };

  const handleChange = (event) => {
    setsignaturebox(event.target.value);
  };

  // Function to handle checkbox change
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  // 1. Fetch user + event details
  useEffect(() => {
    const fetchuserdata = async () => {
      try {
        const response = await apiClient.get(
          `/userdetaila/${
            JSON.parse(localStorage.getItem("user")).user.id
          }`
        );

        setFormData({
          mainLogo: response.data.usersdetails[0].Main_Logo
            ? process.env.REACT_APP_BACKEND_URL +
              response.data.usersdetails[0].Main_Logo
            : null,
          secondaryLogo: response.data.usersdetails[0].Secondary_Logo
            ? process.env.REACT_APP_BACKEND_URL +
              response.data.usersdetails[0].Secondary_Logo
            : null,
          defaultHeaderImage: response.data.usersdetails[0].Header_Images
            ? process.env.REACT_APP_BACKEND_URL +
              response.data.usersdetails[0].Header_Images
            : null,
        });

        setPhone(response.data.usersdetails[0].Phone_Number);
        setCompanyemail(response.data.usersdetails[0].Company_Email);
        setemail(response.data.usersdetails[0].Company_Email);
        setFname(response.data.usersdetails[0].first_name);
        setLname(response.data.usersdetails[0].last_name);
        setcompanyname(response.data.usersdetails[0].companyname);
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    };

    const fetchEventDetails = async () => {
      try {
        const response = await apiClient.get(`/event/${eventID}`);
        if (response.data.success === true) {
          setEventData(response.data.events);
        }
      } catch (error) {
        console.error("Error fetching event details:", error);
      }
    };

    fetchuserdata();
    fetchEventDetails();
  }, [eventID, backendUrl]);

  // 2. Fetch proposal only AFTER EventData is available
  useEffect(() => {

   
    if (!EventData || Object.keys(EventData).length === 0) return;

    const fetchProposal = async () => {
      
      try {
        const response = await apiClient.get(
          `/proposal/${proposalId}`
        );

         

        dispatch(setTitle(response.data.title));

        // Apply replaceSmartText only now (when EventData exists)
       

     /*   const parsedPages = JSON.parse(response.data.content).map((page) => ({
          ...page,
          content: replaceSmartText(page.content),
        }));

        */


        const parsedPages = JSON.parse(response.data.pages).map((page) => ({ 
          ...page, content: replaceSmartText(page.content), }));

        
         

        const parsedTabs = JSON.parse(response.data.content).map((tab) => ({
  ...tab,
  pages: Array.isArray(tab.pages)
    ? tab.pages.map((page) => ({
        ...page,
        content: replaceSmartText(page.content),
      }))
    : [], // fallback to empty array
}));

     

        setProposalstabs(parsedTabs);
        setProposalpages(parsedPages);
      } catch (error) {
        console.error("Error fetching proposal:", error);
      }
    };

    fetchProposal();
  }, [EventData, proposalId]);

  // Helper
  const replaceSmartText = (content) => {
    if (!content) return content;
    return content
      .replace(/{Event_Name}/g, EventData?.name || "Event Name")
      .replace(/{First_Client_First_Name}/g, EventData?.cl_firstname || "")
      .replace(/{First_Client_Last_Name}/g, EventData?.cl_lastname || "")
      .replace(/{First_Client_Email}/g, EventData?.cl_email || "")
      .replace(/{Event_Location}/g, EventData?.address || "")
      .replace(/{Event_Date}/g, EventData?.date ? (() => {
        const [yyyy, mm, dd] = EventData.date.split('-');
        return `${mm}-${dd}-${yyyy}`;
      })() : "")
      .replace(
        /{Event_Type}/g,
        EventData?.get_event_category?.name || "Event Type"
      );
  };

  // Options for the SunEditor instance – upload images to server, store URL in content (not base64)
  const editorOptions = {
    height: 200,
    plugins: allPlugins,
    ...getEditorUploadConfig(),
    buttonList: [
      [
        "codeView",
        "paragraphStyle",
        "bold",
        "underline",
        "italic",
        "strike",
        "table",
        "link",
        "horizontalRule",
        "list",
        "align",
        "hiliteColor",
        "image",
        "video",
      ],
    ],
    imageRotation: false,
    fontSize: [12, 14, 16, 18, 20],
    colorList: [
      [
        "#828282",
        "#FF5400",
        "#676464",
        "#F1F2F4",
        "#FF9B00",
        "#F00",
        "#fa6e30",
        "#000",
        "rgba(255, 153, 0, 0.1)",
        "#FF6600",
        "#0099FF",
        "#74CC6D",
        "#FF9900",
        "#CCCCCC",
      ],
    ],
  };

  const currentDate = new Date();
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const formattedDate = `${
    months[currentDate.getMonth()]
  } ${currentDate.getDate()}, ${currentDate.getFullYear()}`;

  const [showSideCanvas, setShowSideCanvas] = useState(true);
  const [contractCount, setContractCount] = useState(1);

  const [openlist, setOpenlist] = useState("");

  const [questionnaires, setQuestionnaires] = useState("");

  const [contracts, setContracts] = useState([]);

  const [invoices, setInvoices] = useState([]);

  const [proposalpages, setProposalpages] = useState([]);

  const [proposalstabs, setProposalstabs] = useState([]);

  const [pageaddstatus, setPageaddstatus] = useState(true);

  const [purchageorder, setpurchageorder] = useState("");

  const ref2 = useRef([]);
  const handleInput = (e, index) => {
    if (ref2.current[index]) {
      ref2.current[index].style.height = "auto";
      ref2.current[index].style.height = `${
        ref2.current[index].scrollHeight + 16
      }px`;
    }
  };

  const addtoproposal = () => {
    setProposalstabs([
      ...proposalstabs,
      {
        type: "contract",
        id: "v-pills-home",
        title: "Contract",
        content: `<div>
        <h1>Contract</h1>
        <p className="mt-5">Please type or copy and paste the content of your contract here. Alternatively, you can import one of your contract templates using the right panel. </p> 
        <p className="mt-5">If you don’t have a contract, you can browse our template gallery for lawyer-approved free contracts.</p> 
        <p className="mt-5">And remember to delete this text before sending.</p>
        <p className="smart_text">smart_text</p>
      </div>`,
      },
    ]);
  };

  const addpage = () => {
    const pagel = proposalpages.length + 1;
    setProposalpages([
      ...proposalpages,
      {
        name: "Page" + pagel,
        content: `<div>
        <h1>Page ${pagel}</h1>
        <p className="mt-5">Your new page content goes here.</p>
      </div>`,
      },
    ]);
  };

  const addcontracttoproposal = (index) => {
    const newcontract = {
      type: "contract",
      title: contracts[index].title,
      pages: contracts[index].pages.map((page) => ({
        ...page,
        content:
          typeof page.content === "string"
            ? replaceSmartText(page.content)
            : page.content,
      })),
    };

    setProposalstabs((prev) => [...prev, newcontract]);
    setOpenlist("");
    setShowSideCanvas(false);
    setPageaddstatus(false);
  };

  const addinvoicetoproposal = (index) => {
    const newinvoice = {
      type: "invoice",
      title: invoices[index].title,
      pages: invoices[index].invoice_page,
      invoice_item: invoices[index].invoice_item,
      invoice_payment: invoices[index].invoice_payment,
      taxper: invoices[index].taxper,
      tax: invoices[index].tax,
      discountper: invoices[index].discountper,
      discount: invoices[index].discount,
    };
    setProposalstabs([...proposalstabs, newinvoice]);
    setOpenlist("");
    setShowSideCanvas(false);
    setPageaddstatus(false);
  };

  const addquestionnairestoproposal = (index) => {
    const newquestionnaires = {
      type: "questionnaires",
      title: questionnaires[index].title,
      questionss: questionnaires[index].questionss,
    };
    setProposalstabs([...proposalstabs, newquestionnaires]);
    setOpenlist("");
    setShowSideCanvas(false);
    setPageaddstatus(false);
  };

  useEffect(() => {
    dispatch(setTitle("Untitled Proposals"));
  }, []);

  const [tabs, setTabs] = useState([
    {
      id: "v-pills-home",
      title: "Contract",
      content: `<div>
        <h1>Contract</h1>
        <p className="mt-5">Please type or copy and paste the content of your contract here. Alternatively, you can import one of your contract templates using the right panel. </p> 
        <p className="mt-5">If you don’t have a contract, you can browse our template gallery for lawyer-approved free contracts.</p> 
        <p className="mt-5">And remember to delete this text before sending.</p>
        <p className="smart_text">smart_text</p>
      </div>`,
    },
  ]);

  const handleClose = () => {
    setShowSideCanvas(false);
  };

  const handleAddPage = () => {
    setShowSideCanvas(true);
  };

  const handleEditorChange = (content, tabId) => {
    setProposalpages((prevTabs) =>
      prevTabs.map((tab, index3) =>
        index3 === tabId ? { ...tab, content: content } : tab
      )
    );
  };

  const renamepage = (tabId) => {
    const newTitle = prompt("Enter a new title for the page:");
    if (newTitle) {
      setProposalpages((prevTabs) =>
        prevTabs.map((tab, index3) =>
          index3 === tabId ? { ...tab, name: newTitle } : tab
        )
      );
    }
  };

  const handleClick2 = (id) => {
    setTimeout(() => {
      setProposalstabs((prevTabs) =>
        prevTabs.filter((item, index3) => index3 !== id)
      );
    }, 1000);

    if (proposalstabs[id].type == "invoice") {
      setinvoiceadded(false);
    }

    if (proposalstabs[id].type == "contract") {
      setcontractadded(false);
    }
  };

  const handleClick = (id) => {
    setProposalpages((prevTabs) =>
      prevTabs.filter((item, index3) => index3 !== id)
    );
  };

  const handleclone = (cloneid) => {
    const clonetab = proposalpages.filter((item, index3) => index3 === cloneid);

    const pagel = proposalpages.length + 1;

    const newTabTitle = `Page ${pagel}`;

    const newTab = {
      name: newTabTitle,
      content: clonetab[0].content,
    };

    setProposalpages([...proposalpages, newTab]);
  };

  useEffect(() => {
    const fetchContract = async () => {
      try {
        const response = await apiClient.get(
          `/usercontracts/${
            JSON.parse(localStorage.getItem("user")).user.id
          }`
        );
        response.data.forEach((tab, index) => {
          setContracts((contracts) => [...contracts, tab]);
        });
      } catch (error) {
        console.error("Error fetching contract:", error);
      }
    };
    fetchContract();

    const fetchInvoice = async () => {
      try {
        const response = await apiClient.get(
          `/userinvoice/${
            JSON.parse(localStorage.getItem("user")).user.id
          }`
        );

        response.data.forEach((tab, index) => {
          setInvoices((invoices) => [...invoices, tab]);
        });
      } catch (error) {
        console.error("Error fetching contract:", error);
      }
    };
    fetchInvoice();

    const fetchQuestionnaire = async () => {
      try {
        const response = await apiClient.get(
          `/userquestionnaires/${
            JSON.parse(localStorage.getItem("user")).user.id
          }`
        );

        response.data.forEach((tab, index) => {
          var questions = [];
          tab.question.map((tab1) => {
            const newques = {
              type: tab1.type,
              showServiceInfo: tab1.showServiceInfo,
              ques: tab1.ques,
              ques2: tab1.ques2,
              placeholder: tab1.placeholder,
              placeholder2: tab1.placeholder2,
              option: JSON.parse(tab1.options),
              optionadd: tab1.optionadd,
            };

            questions.push(newques);
          });

          const newelement = { title: tab.title, questionss: questions };

          setQuestionnaires((questionnaires) => [
            ...questionnaires,
            newelement,
          ]);
        });
      } catch (error) {
        console.error("Error fetching contract:", error);
      }
    };
    fetchQuestionnaire();
  }, []);

  useEffect(() => {
    // what should happen after the initial render
    const indexval = proposalstabs.length;
    const buttonid = `${indexval - 1}-tab`;
    const activebutton = document.getElementById(buttonid);
    if (activebutton) {
      //activebutton.click();
    }
  }, [proposalstabs.length]);

  const handleSubmit = async () => {
    try {
      const response = await apiClient.put(
        `/proposal/${proposalId}`,
        {
          title: title,
          user_id: JSON.parse(localStorage.getItem("user")).user.id,
          content: JSON.stringify(proposalstabs),
          pages: JSON.stringify(proposalpages),
        }
      );
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Contract saved successfully!",
      });
      navigate("/proposals");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: getErrorMessage(error),
      });
    }
  };

  function formatDateToMMDDYYYY(date) {
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Get month and pad with leading zero if needed
    const day = String(d.getDate()).padStart(2, "0"); // Get day and pad with leading zero if needed
    const year = d.getFullYear(); // Get the year

    return `${month}/${day}/${year}`;
  }

  useEffect(() => {
    var totalprice = 0;
    proposalstabs.map((ptab) => {
      if (ptab.type == "contract" && contractadded == false) {
        setcontractadded(true);
      } else if (ptab.type == "invoice" && invoiceadded == false) {
        setinvoiceadded(true);
      }

      if (ptab.type == "invoice") {
        ptab.invoice_item.map((tab1) => {
          totalprice =
            parseFloat(totalprice) +
            parseFloat(tab1.price) * parseFloat(tab1.qty);
        });

        setsubtotalprice(totalprice);
        if (parseInt(ptab.taxper) > 0) {
          totalprice =
            parseFloat(totalprice) +
            parseFloat((ptab.taxper * totalprice) / 100);
          settaxval((parseFloat(ptab.taxper) * totalprice) / 100);
        } else {
          totalprice = parseFloat(totalprice) + parseFloat(ptab.tax);
          settaxval(ptab.tax);
        }
        if (parseInt(ptab.discountper)) {
          totalprice =
            totalprice - parseInt((ptab.discountper * totalprice) / 100);
          setdiscountval((ptab.discountper * totalprice) / 100);
        } else {
          totalprice = totalprice - parseInt(ptab.discount);
          setdiscountval(ptab.discount);
        }
        settotalprice(totalprice);
      }
    });

    if (proposalstabs.length > 0) {
      const proposaltablenght = proposalstabs.length - 1;

      var buttonid = "";

      if (proposalstabs[proposaltablenght].type == "contract") {
        buttonid = `ctab0${proposaltablenght}`;
      } else if (proposalstabs[proposaltablenght].type == "invoice") {
        buttonid = `invoicetab${proposaltablenght}${proposaltablenght}`;
      } else if (proposalstabs[proposaltablenght].type == "questionnaires") {
        buttonid = `qutab${proposaltablenght}`;
      }

      const activebutton = document.getElementById(buttonid);
      if (activebutton) {
        activebutton.click();
      }
    }
  }, [proposalstabs]);

  useEffect(() => {
    setTimeout(function () {
      ref2.current.map((tab, index) => {
        if (ref2.current[index]) {
          ref2.current[index].style.height = "auto";
          ref2.current[index].style.height = `${
            ref2.current[index].scrollHeight + 16
          }px`;
        }
      });
    }, 2000);
  }, [proposalstabs]);

  const expandtextbox = () => {
    setTimeout(function () {
      ref2.current.map((tab, index) => {
        if (ref2.current[index]) {
          ref2.current[index].style.height = "auto";
          ref2.current[index].style.height = `${
            ref2.current[index].scrollHeight + 16
          }px`;
        }
      });
    }, 1000);
  };

  const handleDueDateChange = (tabIndex, paymentIndex, newDueDate) => {
    let currentDate = new Date();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    let options = {
      timeZone: timeZone, // Specify your timezone
      year: "numeric",
      month: "long",
      day: "numeric",
    };

    const inputDate = newDueDate + "T00:00:00";
    //const inputDate = event.target.value+'T00:00:00';
    const newDueDate1 = new Date(inputDate);

    if (isNaN(newDueDate1)) {
      console.error("Invalid date:", newDueDate);
      return;
    }

    const formattedDueDate = newDueDate1.toLocaleString("en-US", options);

    const updatedPayments = [...payments];

    var y = currentDate.getFullYear();
    var m = currentDate.getMonth();
    var d = currentDate.getDate();

    var y2 = newDueDate1.getFullYear();
    var m2 = newDueDate1.getMonth();
    var d2 = newDueDate1.getDate();

    var comparedate1 = new Date(y, m, d);
    var comparedate2 = new Date(y2, m2, d2);

    if (comparedate2 > comparedate1) {
      var paymentIdnew = "Up comming";
    } else if (comparedate2 < comparedate1) {
      //updatedPayments[index].paymentId = "";
      var paymentIdnew = "Over Due";
    } else {
      //updatedPayments[index].paymentId = "Due Today";
      var paymentIdnew = "Due Today";
    }

    setProposalstabs((prevTabs) =>
      prevTabs.map((tab, tIndex) =>
        tIndex === tabIndex
          ? {
              ...tab,
              invoice_payment: tab.invoice_payment.map((payment, pIndex) =>
                pIndex === paymentIndex
                  ? {
                      ...payment,
                      dueDate: formattedDueDate,
                      paymentId: paymentIdnew,
                    }
                  : payment
              ),
            }
          : tab
      )
    );
  };

  const handleDateChange = (event, index) => {
    let currentDate = new Date();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    let options = {
      timeZone: timeZone, // Specify your timezone
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    const inputDate = event.target.value + "T00:00:00";
    const newDueDate = new Date(inputDate);

    if (isNaN(newDueDate)) {
      console.error("Invalid date:", inputDate);
      return;
    }

    const formattedDueDate = newDueDate.toLocaleString("en-US", options);

    const updatedPayments = [...payments];

    var y = currentDate.getFullYear();
    var m = currentDate.getMonth();
    var d = currentDate.getDate();

    var y2 = newDueDate.getFullYear();
    var m2 = newDueDate.getMonth();
    var d2 = newDueDate.getDate();

    var comparedate1 = new Date(y, m, d);
    var comparedate2 = new Date(y2, m2, d2);

    if (comparedate2 > comparedate1) {
      updatedPayments[index].paymentId = "Up comming";
    } else if (comparedate2 < comparedate1) {
      updatedPayments[index].paymentId = "Over Due";
    } else {
      updatedPayments[index].paymentId = "Due Today";
    }
    updatedPayments[index].dueDate = formattedDueDate;

    //alert(updatedPayments);
    setPayments(updatedPayments);
  };

  const toggleDueDateBox = (indexpro, index) => {
    if (smartdate) {
      const result = new Date(EventData.date);
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      let options = {
        timeZone: timeZone, // Specify your timezone
        year: "numeric",
        month: "long",
        day: "numeric",
      };

      if (smartyear === "before event date") {
        if (smartmonth == "day(s)") {
          result.setDate(result.getDate() - Number(smartday));
        } else if (smartmonth == "Week(s)") {
          result.setDate(result.getDate() - Number(smartday) * 7);
        } else if (smartmonth == "month(s)") {
          result.setMonth(result.getMonth() - Number(smartday));
        }
      } else if (smartyear === "after event date") {
        if (smartmonth == "day(s)") {
          result.setDate(result.getDate() + Number(smartday));
        } else if (smartmonth == "Week(s)") {
          result.setDate(result.getDate() + Number(smartday) * 7);
        } else if (smartmonth == "month(s)") {
          result.setMonth(result.getMonth() + Number(smartday));
        }
      } else if (smartyear === "after invoice has been sent") {
        result.setDate(result.getDate());
      }

      const formattedDate = result.toLocaleString("en-US", options);

      // const formattedDate = formatDateToMMDDYYYY(updatedLocalDate);

      // alert(formattedDate);

      // updatedPayments = [...payments];
      const newProposalstabs = proposalstabs.map((tab, tabIndex) => {
        if (tabIndex === indexpro) {
          return {
            ...tab,
            invoice_payment: tab.invoice_payment.map(
              (payment, paymentIndex) => {
                if (paymentIndex === index) {
                  return {
                    ...payment,
                    dueDate: formattedDate,
                    paymentId: smartyear,
                    type: "smartdate",
                    smartdays: smartday,
                  };
                }
                return payment;
              }
            ),
          };
        }
        return tab;
      });

      setProposalstabs(newProposalstabs);
    }
    setShowDueDateBox((prevIndex) => (prevIndex !== index ? index : null));
  };

  const handlePropagation = (e) => {
    e.stopPropagation();
  };

  const handleOptionSelectsmartmonth = (value) => {
    setsmartmonth(value);
  };

  const handleOptionSelectsmartyear = (value) => {
    setsmartyear(value);
  };

  const handleOptionSelect = (value) => {
    // alert(value);

    if (value == "Smart date") {
      // alert('dhirendra');
      setsmartdate(true);
    } else {
      setsmartdate(false);
    }
  };

  const [isProcessed, setIsProcessed] = useState(false);

  useEffect(() => {
    // Check if proposalstabs is loaded and hasn't been processed yet
    if (
      proposalstabs.length > 0 &&
      !isProcessed &&
      Object.keys(EventData).length > 0
    ) {
      proposalstabs.forEach((ptab, pindex) => {
        if (ptab.type === "invoice") {
          const [year, month, day] = EventData.date.split("-").map(Number);

          ptab.invoice_payment.forEach((paymenttab, paymentIndex) => {
            if (paymenttab.type === "smartdate") {
              const result = new Date(Date.UTC(year, month - 1, day, 12, 0, 0));

              const timeType = paymenttab.timetype.toLowerCase();

              if (paymenttab.paymentId === "before event date") {
                if (timeType === "day(s)") {
                  result.setUTCDate(
                    result.getUTCDate() - Number(paymenttab.smartdays)
                  );
                } else if (timeType === "week(s)") {
                  result.setUTCDate(
                    result.getUTCDate() - Number(paymenttab.smartdays) * 7
                  );
                } else if (timeType === "month(s)") {
                  result.setUTCMonth(
                    result.getUTCMonth() - Number(paymenttab.smartdays)
                  );
                }
              } else if (paymenttab.paymentId === "after event date") {
                if (timeType === "day(s)") {
                  result.setUTCDate(
                    result.getUTCDate() + Number(paymenttab.smartdays)
                  );
                } else if (timeType === "week(s)") {
                  result.setUTCDate(
                    result.getUTCDate() + Number(paymenttab.smartdays) * 7
                  );
                } else if (timeType === "month(s)") {
                  result.setUTCMonth(
                    result.getUTCMonth() + Number(paymenttab.smartdays)
                  );
                }
              } else if (
                paymenttab.paymentId === "after invoice has been sent"
              ) {
                result.setUTCDate(result.getUTCDate());
              }

              const isoDate = result.toISOString();

              const userLocalDate = new Date(isoDate).toLocaleDateString(
                "en-US",
                {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                }
              );

              // Update the state with the new due date
              setProposalstabs((prevTabs) => {
                return prevTabs.map((tab, index) => {
                  if (index === pindex) {
                    return {
                      ...tab,
                      invoice_payment: tab.invoice_payment.map(
                        (payment, pIdx) =>
                          pIdx === paymentIndex
                            ? { ...payment, dueDate: userLocalDate }
                            : payment
                      ),
                    };
                  }
                  return tab;
                });
              });

              // Mark as processed
            }
            setIsProcessed(true);
          });
        }
      });
    }
  }, [proposalstabs, isProcessed, EventData]);


  

  return (
    <>
      <SendToCustomerInfoModal
        type="Proposal"
        id={proposalId}
        title={title}
        contentpage={proposalstabs}
        details={proposalpages}
        invoicenumber={invoicenumber}
        purchageorder={purchageorder}
        usersignature={usersignature}
      />
      <div className="container-fluid p-lg-5 p-md-5 p-3">
        <div className="row g-lg-5 g-md-5 g-3 px-lg-5">
          <div className="col-md-12 text-end mt-n1 mb-3"></div>

          {/* Add Page part */}
          <div className="col-lg-8">
            <div className="text-editor px-2 px-md-5 py-3">
              <div className="tab-content h-100" id="v-pills-tabContent">
                {/* add page */}

                {proposalpages.map((addedpagesmain, pageindexmain) => (
                  <>
                    <div
                      key={pageindexmain}
                      className={
                        "tab-pane fade " +
                        (pageindexmain == 0 ? "show active" : "")
                      }
                      id={`adpage${pageindexmain}`}
                      role="tabpanel"
                      aria-labelledby={`${pageindexmain}-tab`}
                    >
                      <div className="position-relative overflow-hidden">
                        <SunEditor
                          setOptions={editorOptions}
                          ref={editorRef}
                          defaultValue={addedpagesmain.content}
                          onChange={(content) =>
                            handleEditorChange(content, pageindexmain)
                          }
                        />
                      </div>
                    </div>
                  </>
                ))}

                {proposalstabs.map((tab, indexpro) => (
                  <>
                    {tab.type == "contract" && (
                      <>
                        {tab.pages.map((tabpages, cpagesindex) => (
                          <>
                            <div
                              key={cpagesindex}
                              className={
                                "tab-pane fade " +
                                (proposalpages.length === 0 && cpagesindex === 0
                                  ? "show active"
                                  : "")
                              }
                              id={`cpage${cpagesindex}`}
                              role="tabpanel"
                              aria-labelledby={`${tab.id}-tab`}
                            >
                              {cpagesindex == 0 ? <TextEditorToSection /> : ""}
                              <div className="position-relative overflow-hidden">
                                <SunEditor
                                  setOptions={editorOptions}
                                  ref={editorRef}
                                  defaultValue={tabpages.content}
                                />
                              </div>
                            </div>
                          </>
                        ))}
                      </>
                    )}

                    {tab.type == "invoice" && (
                      <>
                        {" "}
                        <div
                          key={indexpro}
                          className={
                                "tab-pane fade " +
                                (proposalpages.length === 0 && indexpro === 0
                                  ? "show active"
                                  : "")
                              }
                          id={`tab${indexpro}`}
                          role="tabpanel"
                          aria-labelledby={`tab${indexpro}`}
                        >
                          {/* invoice section main part start */}

                          <section className="section_container">
                            {/* Customer Details here */}
                            <div className="customer_details">
                              {/* Customer info */}
                              {formData.mainLogo ? (
                                <>
                                  <div className="logo text-center">
                                    <img
                                      src={formData.secondaryLogo}
                                      alt="Main Logo Preview"
                                      className="mainimgpath"
                                      style={{ height: "150px" }}
                                    />
                                  </div>
                                </>
                              ) : (
                                <></>
                              )}
                              <div className="title">
                                <h4>{companyname}</h4>
                              </div>
                              <div className="item">
                                <span style={{ textTransform: "capitalize" }}>
                                  {fname} {lname}{" "}
                                </span>
                                <span>{phone}</span>
                                <span>{companyemail}</span>
                              </div>
                            </div>

                            {/* Invoice content */}
                            <div className="invoice">
                              <h3 style={{ margin: "0px 40px" }}>Invoice</h3>

                              {/* invoice table */}
                              <div className="invoice-table d-flex align-items-center flex-wrap justify-content-between mt-4">
                                <div
                                  className="table_item  invoice_td position-relative"
                                  type="button"
                                >
                                  <span className="hover_effect">Bill to</span>
                                  <br />
                                  <span>
                                    {EventData.cl_firstname}{" "}
                                    {EventData.cl_lastname}
                                  </span>
                                </div>
                                <div
                                  className="table_item  invoice_td position-relative"
                                  type="button"
                                  style={{ marginRight: "4%" }}
                                >
                                  <span className="hover_effect">
                                    invoice #
                                  </span>
                                  <br />
                                  <span>{invoicenumber}</span>
                                </div>

                                <div className="table_item  purchase_td position-relative">
                                  <span className="hover_effect">
                                    Purchase order #
                                  </span>
                                  <br />
                                  <span>
                                    <input
                                      className="purchageorder"
                                      type="text"
                                      style={{ backgroundColor: "#e8eff7" }}
                                      defaultValue={purchageorder}
                                      onChange={(e) =>
                                        setpurchageorder(e.target.value)
                                      }
                                    />
                                  </span>
                                </div>
                              </div>

                              <div className="invoice-table d-flex align-items-center flex-wrap justify-content-between mt-4">
                                <div></div>
                                <div className="table_item table_item_date_issued position-relative">
                                  <span>Date Issued</span> <br />
                                  <div
                                    className="date position-absolute"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {formattedDate}
                                  </div>
                                </div>
                                <div className="table_item position-relative">
                                  <span>Next Payment Due</span>
                                  <br />
                                  <div
                                    className="date position-absolute"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {tab.invoice_payment[0].dueDate}
                                  </div>
                                </div>
                              </div>

                              {/* service area */}
                              <div className="service_area d-flex align-items-center justify-content-between py-3">
                                <div className="service_item">
                                  <div className="service_info_top">
                                    <span>SERVICE INFO</span>
                                  </div>
                                </div>
                                <div className="service_item d-flex align-items-center">
                                  <span className="me-5">QTY</span>
                                  <span>UNIT</span>
                                </div>
                                <div className="service_item">
                                  <span className="me-3">
                                    {" "}
                                    {/*TAX*/}&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;
                                    &nbsp;&nbsp;&nbsp;{" "}
                                  </span>
                                  <span>PRICE</span>
                                </div>
                              </div>

                              {/* create new service */}
                              {/* Render dynamic services */}

                              {tab.invoice_item.map((service, index) => (
                                <div
                                  key={index}
                                  className="create_new_service flex-wrap d-flex align-items-center justify-content-between py-3 position-relative"
                                >
                                  <div className="service_item position-relative">
                                    <div
                                      className="service_info_box"
                                      style={{ marginTop: "41px" }}
                                    >
                                      <div className="service_info">
                                        <span className="pricespan2">*</span>
                                        <input
                                          type="text"
                                          id={`name-${index}`}
                                          placeholder="Type or Select a Service"
                                          defaultValue={service.type}
                                        />
                                        <small></small>
                                      </div>
                                      <div className="desc mt-2">
                                        {" "}
                                        &nbsp;
                                        {/* <textarea name="" className="textare" placeholder='Enter a description' value={service.descp}  onChange={(e) => changedesc(e,index)}></textarea> */}
                                        {/* <input type='text' placeholder='Enter a description' value={service.descp}  onChange={(e) => changedesc(e,index)} /> */}
                                      </div>
                                    </div>

                                    {/* Select item */}
                                  </div>
                                  <div className="service_item d-flex align-items-center">
                                    {/* QYT field */}
                                    <span className="me-2 qyt">
                                      <span className="pricespan">*</span>
                                      <input
                                        type="number"
                                        placeholder="QYT"
                                        defaultValue={service.qty}
                                      />
                                    </span>

                                    {/* UNIT Field */}
                                    <span className="position-relative">
                                      <span className="pricespan">*</span>
                                      <UnitOption
                                        indexval={index}
                                        rawselectedOption={service.unit_option}
                                      />
                                    </span>
                                  </div>
                                  <div className="service_item d-flex align-items-center">
                                    <div className="form-check ">
                                      {/* <input
                              className='form-check-input'
                              type='checkbox'
                              name='tax'
                              value=''
                              id='flexCheckDefault'
                              checked={service.tax ? 'checked' : ''}
                            /> */}
                                    </div>
                                    <div className="form-check qyt">
                                      <span className="pricespan">*</span>
                                      <input
                                        type="number"
                                        placeholder="Price"
                                        defaultValue={service.price}
                                      />
                                      <small></small>
                                    </div>
                                  </div>

                                  {/* Delete button */}
                                  <div className="position-absolute delete_btn">
                                    <button>
                                      <i className="fas fa-trash-alt"></i>
                                    </button>
                                  </div>

                                  <div className="textare2">
                                    <span className="markred">*</span>

                                    <textarea
                                      ref={(el) => (ref2.current[index] = el)}
                                      placeholder="Enter a description"
                                      rows={1}
                                      onInput={(e) => handleInput(e, index)}
                                      name={index}
                                      id={`desc-${index}`}
                                      className="textare"
                                      defaultValue={service.descp}
                                    />
                                    <small></small>
                                  </div>
                                </div>
                              ))}

                              {/* add new item button  */}
                              <div className="create_new_service py-5">
                                <button>+ Add item / package</button>
                              </div>

                              {/* Summary*/}
                              <div className="card-body">
                                <div className="row flex-column-reverse flex-md-row row-gap-4 row-gap-md-0">
                                  <div className="col-md-5 d-flex align-items-end"></div>

                                  <div className="col-md-7 ml-auto">
                                    <table className="table create_invoice_table table-clear">
                                      <tbody>
                                        <tr>
                                          <td className="left">
                                            <span>Subtotal</span>
                                          </td>
                                          <td className="right">
                                            ${subtotalprice}
                                          </td>
                                        </tr>
                                        {/* Tax box */}
                                        <tr>
                                          <td className="left position-relative">
                                            <span className="pointer">
                                              Tax {/* <span>8.5%</span> */}
                                            </span>
                                            {showTaxBox && (
                                              <div className="edit_discount_box edit_tax_box position-relative">
                                                <div className="box_header d-flex align-items-center justify-content-between mb-2">
                                                  <h5>Edit Tax</h5>
                                                  <span>
                                                    <i className="fas fa-close"></i>
                                                  </span>
                                                </div>
                                                <div className="box-content mt-2 d-flex align-items-center">
                                                  <input
                                                    type="number"
                                                    className="me-2"
                                                    placeholder="Tax"
                                                    defaultValue=""
                                                  />

                                                  <div className="input-group">
                                                    <span
                                                      className={`input-group-text `}
                                                      id="basic-addon1"
                                                    >
                                                      %
                                                    </span>
                                                    <span
                                                      className={`input-group-text `}
                                                      id="basic-addon1"
                                                    >
                                                      $
                                                    </span>
                                                  </div>

                                                  {/* delete button */}
                                                  <div>
                                                    {" "}
                                                    <i className="fas fa-trash text-danger"></i>
                                                  </div>
                                                </div>

                                                <div className="discount_arrow"></div>
                                              </div>
                                            )}
                                          </td>
                                          <td className="right">${taxval}</td>
                                        </tr>

                                        {/* add discount box */}
                                        <tr>
                                          <td className="left position-relative">
                                            {showDiscountBox ? (
                                              <span className="pointer">
                                                Discount
                                              </span>
                                            ) : (
                                              <span className="pointer">
                                                + Add Discount
                                              </span>
                                            )}

                                            {/* edit discount box */}
                                            {showDiscountBox && (
                                              <div className="edit_discount_box position-relative">
                                                <div className="box_header d-flex align-items-center justify-content-between mb-2">
                                                  <h5>Edit Discount</h5>
                                                  <span>
                                                    <i className="fas fa-close"></i>
                                                  </span>
                                                </div>
                                                <div className="box-content mt-2 d-flex align-items-center">
                                                  <input
                                                    type="number"
                                                    className="me-2"
                                                    defaultValue=""
                                                  />

                                                  <div className="input-group">
                                                    <span
                                                      className={`input-group-text `}
                                                      id="basic-addon1"
                                                    >
                                                      %
                                                    </span>
                                                    <span
                                                      className={`input-group-text `}
                                                      id="basic-addon1"
                                                    >
                                                      $
                                                    </span>
                                                  </div>

                                                  {/* delete button */}
                                                  <div>
                                                    {" "}
                                                    <i className="fas fa-trash text-danger"></i>
                                                  </div>
                                                </div>

                                                <div className="discount_arrow"></div>
                                              </div>
                                            )}
                                          </td>
                                          <td className="right">
                                            <strong>${discountval}</strong>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="left">
                                            <span>Total USD</span>
                                          </td>
                                          <td className="right">
                                            <strong> {totalprice} </strong>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                          {/* PAYMENT SCHEDULE */}
                          <section className="section_container my-4 px-2 px-md-5 py-5">
                            <div className="title">
                              <h4>PAYMENT SCHEDULE</h4>
                            </div>
                            {/* <div className='table-responsive mt-5'>
        {" "}
        <table className='table invoice_table'>
          <thead>
            <tr>
              <th scope='col'>AMOUNT</th>
              <th scope='col'>DUE DATE</th>
              <th scope='col'>PAYMENT DATE</th>
              <th scope='col'>PAYMENT ID</th>
              <th scope='col'>STATUS</th>
            </tr>
          </thead>
          <tbody>
            {payments.map((payment, index) => (
              <tr key={index}>
                <th scope='row ' className='hover_payment'>
                  <span>${payment.amount}</span>
                </th>
                <td
                  className='due_date hover_payment'
                  style={{ zIndex: 9999, position: "relative" }}>
                  <span
                    style={{ fontSize: "16px" }}
                    onClick={() => toggleDueDateBox(index)}>
                    {payment.dueDate}
                  </span>
                  Due date box
                </td>
                <td>-</td>
                <td>{payment.paymentId}</td>
                Delete payment
                <td
                  className='text-center position-relative'
                  style={{ cursor: "pointer" }}>
                  <i
                    className='fas fa-trash text-danger'
                    onClick={() => deletePayment(index)}></i>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div> */}
                            <div className="payment_schedule_container mt-2">
                              <table>
                                <thead>
                                  <tr>
                                    <th scope="col" style={{ width: "74px" }}>
                                      AMOUNT
                                    </th>
                                    <th scope="col">DUE DATE</th>
                                    <th scope="col">PAYMENT DATE</th>
                                    <th scope="col">PAYMENT ID</th>
                                    <th scope="col" style={{ width: "74px" }}>
                                      STATUS
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {tab.invoice_payment.map((data, i) => (
                                    <tr key={i}>
                                      <td data-label="Amount">
                                        <span className="hover_item">
                                          ${data.amount}
                                        </span>
                                      </td>
                                      <td
                                        data-label="DUE DATE"
                                        className="due_date hover_payment position-relative"
                                      >
                                        <span
                                          className="hover_item"
                                          onClick={() =>
                                            toggleDueDateBox(indexpro, i)
                                          }
                                        >
                                          {data.dueDate}

                                          {showDueDateBox === i && (
                                            <div
                                              className="due_date_box"
                                              onClick={handlePropagation}
                                            >
                                              <div className="due_date_box_header d-flex align-items-center justify-content-between">
                                                <h4>Set Payment Due</h4>
                                                <span
                                                  onClick={() =>
                                                    toggleDueDateBox(
                                                      indexpro,
                                                      i
                                                    )
                                                  }
                                                >
                                                  <i className="fas fa-close"></i>
                                                </span>
                                              </div>
                                              <div className="arrow"></div>

                                              <div className="due_date_box_content mt-2">
                                                {smartdate && (
                                                  <CommonDropdownMenuThree
                                                    options={options}
                                                    suboption={options_sub}
                                                    handleOptionSelect={
                                                      handleOptionSelect
                                                    }
                                                    rawselectedOption={
                                                      options[1]
                                                    }
                                                  />
                                                )}

                                                {!smartdate && (
                                                  <CommonDropdownMenuThree
                                                    options={options}
                                                    suboption={options_sub}
                                                    handleOptionSelect={
                                                      handleOptionSelect
                                                    }
                                                    rawselectedOption={
                                                      options[0]
                                                    }
                                                  />
                                                )}

                                                {smartdate && (
                                                  <div className="d-flex smartdate">
                                                    <input
                                                      className="smardatinp"
                                                      value={smartday}
                                                      onChange={(e) =>
                                                        setsmartday(
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                    &nbsp;
                                                    <CommonDropdownMenufour
                                                      options={options2}
                                                      handleOptionSelect={
                                                        handleOptionSelectsmartmonth
                                                      }
                                                      rawselectedOption={
                                                        options2[0]
                                                      }
                                                    />
                                                    &nbsp;
                                                    <CommonDropdownMenufour
                                                      options={options3}
                                                      handleOptionSelect={
                                                        handleOptionSelectsmartyear
                                                      }
                                                      rawselectedOption={
                                                        options3[0]
                                                      }
                                                    />
                                                  </div>
                                                )}

                                                {!smartdate && (
                                                  <div className="mt-3 date_input">
                                                    <input
                                                      type="date"
                                                      onChange={(event) =>
                                                        handleDueDateChange(
                                                          indexpro,
                                                          i,
                                                          event.target.value
                                                        )
                                                      }
                                                      value={payments?.dueDate}
                                                    />
                                                  </div>
                                                )}

                                                <div className="mt-3 text-end">
                                                  <button
                                                    onClick={() =>
                                                      toggleDueDateBox(
                                                        indexpro,
                                                        i
                                                      )
                                                    }
                                                  >
                                                    Save
                                                  </button>
                                                </div>
                                              </div>

                                              <div className="arrow"></div>
                                            </div>
                                          )}
                                        </span>
                                      </td>
                                      <td data-label="PAYMENT DATE">-</td>
                                      <td data-label="PAYMENT ID">
                                        {data.paymentId}
                                      </td>
                                      <td
                                        data-label="STATUS"
                                        className="text-end position-relative"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <i className="fas fa-trash text-danger"></i>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                            {/* add new payment button  */}
                            <div className="add-new-payment py-5">
                              <button>+ Add Another Payment</button>
                            </div>
                          </section>
                        </div>
                        {/* invoice section main part end */}
                        {tab.pages.map((tabpages, invoicepageindex) => (
                          <>
                            <div
                              key={invoicepageindex}
                              className={"tab-pane fade "}
                              id={`invoicepage${invoicepageindex}`}
                              role="tabpanel"
                              aria-labelledby={`${tab.id}-tab`}
                            >
                              <div className="position-relative overflow-hidden">
                                <SunEditor
                                  setOptions={editorOptions}
                                  ref={editorRef}
                                  defaultValue={tabpages.content}
                                />
                              </div>
                            </div>
                          </>
                        ))}
                        <div
                          className="tab-pane "
                          id="v-pills-profile"
                          role="tabpanel"
                          aria-labelledby="v-pills-profile-tab"
                          tabIndex="0"
                        >
                          {proposalstabs
                            .filter(
                              (tab) =>
                                tab.type === "invoice" &&
                                tab.invoice_payment?.length > 0
                            )
                            .map((invoiceTab, idx) => (
                              <CreatePayContent
                                key={idx}
                                paidpayment1={
                                  invoiceTab.invoice_payment[0]?.amount ?? 0
                                }
                                duedate={invoiceTab.invoice_payment[0].dueDate}
                                invoicelength={
                                  invoiceTab.invoice_payment.length
                                }
                              />
                            ))}
                        </div>
                      </>
                    )}

                    {tab.type == "questionnaires" && (
                      <>
                        {""}
                        <div
                          key={indexpro}
                         className={
                                "tab-pane fade " +
                                (proposalpages.length === 0 && indexpro === 0
                                  ? "show active"
                                  : "")
                              }
                          id={`tab${indexpro}`}
                          role="tabpanel"
                          aria-labelledby={`tab${indexpro}`}
                        >
                          <div className="position-relative overflow-hidden">
                            <div className="form_container tab-content">
                              {tab.questionss.map((tabques, ind) => (
                                <>
                                  {/* start of   questionnaires */}

                                  {tabques.type == "shorttext" && (
                                    <div
                                      className="col-md-12 d-flex center"
                                      key={ind}
                                    >
                                      <div className="col-md-12 left">
                                        <label
                                          htmlFor="name"
                                          className="form-label mt-0"
                                        >
                                          {tabques.ques}
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          id="name"
                                          name="name"
                                          placeholder={tabques.placeholder}
                                        />
                                      </div>
                                    </div>
                                  )}

                                  {tabques.type == "FullwidthText" && (
                                    <div className="col-md-12 center">
                                      <div className="col-md-12 center">
                                        &nbsp;
                                      </div>
                                      <div className="col-md-12 ">
                                        <label
                                          htmlFor="name"
                                          className="form-label mt-0"
                                        >
                                          {tabques.placeholder}
                                        </label>
                                      </div>
                                      <div className="col-md-12 center">
                                        &nbsp;
                                      </div>
                                    </div>
                                  )}

                                  {tabques.type == "2ColumnText" && (
                                    <div className="col-md-12 d-flex ">
                                      <div className="col-md-6 margin ">
                                        <label
                                          htmlFor="name"
                                          className="form-label mt-0"
                                        >
                                          {tabques.placeholder}
                                        </label>
                                      </div>
                                      <div className="col-md-6 margin">
                                        <label
                                          htmlFor="name"
                                          className="form-label mt-0"
                                        >
                                          {tabques.placeholder}
                                        </label>
                                      </div>
                                    </div>
                                  )}

                                  {tabques.type == "twofields" && (
                                    <div className="col-md-12 d-flex">
                                      <div className="col-md-6 margin left ">
                                        <label
                                          htmlFor="name"
                                          className="form-label mt-0"
                                        >
                                          {tabques.ques}
                                        </label>

                                        <input
                                          type="text"
                                          className="form-control"
                                          id="name"
                                          name="name"
                                          placeholder={tabques.placeholder}
                                        />
                                      </div>
                                      <div className="col-md-6 margin left">
                                        <label
                                          htmlFor="name"
                                          className="form-label mt-0"
                                        >
                                          {tabques.ques2}
                                        </label>

                                        <input
                                          type="text"
                                          className="form-control"
                                          id="name"
                                          name="name"
                                          placeholder={tabques.placeholder2}
                                        />
                                      </div>
                                    </div>
                                  )}

                                  {tabques.type == "longtext" && (
                                    <div className="col-md-12 d-flex left">
                                      <div className="col-md-12 left">
                                        <label
                                          htmlFor="name"
                                          className="form-label mt-0"
                                        >
                                          {tabques.ques}
                                        </label>
                                        <textarea
                                          placeholder={tabques.placeholder}
                                          rows={1}
                                          cols="50"
                                          name=""
                                          id=""
                                          className="textare1"
                                        />
                                      </div>
                                    </div>
                                  )}

                                  {tabques.type == "Dropdown" && (
                                    <>
                                      {" "}
                                      {tabques.optionadd == 0 ? (
                                        <div className="col-md-12 left">
                                          {" "}
                                          <div className="col-md-12 left">
                                            <label
                                              htmlFor="name"
                                              className="form-label mt-0"
                                            >
                                              {tabques.ques}
                                            </label>

                                            <select className="selectfull">
                                              {tabques.option.map(
                                                (optiontab, index2) => (
                                                  <option key={index2}>
                                                    {optiontab.listpotion}{" "}
                                                  </option>
                                                )
                                              )}
                                            </select>
                                          </div>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </>
                                  )}

                                  {tabques.type == "Singlechoice" && (
                                    <>
                                      <div className="col-md-12 mb-10">
                                        <label
                                          htmlFor="name"
                                          className="form-label mt-0"
                                        >
                                          {tabques.ques}
                                        </label>
                                        {tabques.option.map(
                                          (optiontab, index2) => (
                                            <div
                                              className="col-md-12 gapbetween"
                                              key={index2}
                                            >
                                              <div className="col-md-10">
                                                <input
                                                  type="radio"
                                                  id={optiontab.listpotion}
                                                  name="fav_language"
                                                  defaultValue={
                                                    optiontab.listpotion
                                                  }
                                                />
                                                <label
                                                  htmlFor={optiontab.listpotion}
                                                >
                                                  {optiontab.listpotion}{" "}
                                                </label>
                                                <br />
                                              </div>
                                            </div>
                                          )
                                        )}
                                      </div>
                                    </>
                                  )}

                                  {tabques.type == "Multichoice" && (
                                    <>
                                      {" "}
                                      <div className="col-md-12 mb-10">
                                        <label
                                          htmlFor="name"
                                          className="form-label mt-0"
                                        >
                                          {tabques.ques}
                                        </label>
                                        {tabques.option.map(
                                          (optiontab, index2) => (
                                            <div
                                              className="col-md-12"
                                              key={index2}
                                            >
                                              <input
                                                type="checkbox"
                                                id={index2}
                                                name="fav_language"
                                                defaultValue={
                                                  optiontab.listpotion
                                                }
                                              />
                                              <label htmlFor={index2}>
                                                {optiontab.listpotion}{" "}
                                              </label>
                                              <br />
                                            </div>
                                          )
                                        )}
                                      </div>
                                    </>
                                  )}

                                  {tabques.type == "DatePicker" && (
                                    <div className="col-md-12 d-flex left">
                                      <div className="col-md-12">
                                        <label
                                          htmlFor="name"
                                          className="form-label mt-0"
                                        >
                                          {tabques.ques}
                                        </label>
                                        <input
                                          type="date"
                                          className="datetype"
                                        />
                                      </div>
                                    </div>
                                  )}

                                  {/* end of   questionnaires */}
                                </>
                              ))}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </>
                ))}

                {proposalstabs.length == 0 && proposalpages.length == 0 && (
                  <div
                    onClick={handleAddPage}
                    className="add-page add-proposal  d-flex flex-column justify-content-center align-items-center text-center h-100"
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasRight"
                    aria-controls="offcanvasRight"
                  >
                    <img src="/img/edit_icon.png" alt="ICON" />
                    <h2 className="mt-4">Add page</h2>
                  </div>
                )}

                <div
                  className={"tab-pane fade "}
                  id="sign"
                  role="tabpanel"
                  aria-labelledby={`sign-tab`}
                  style={{ background: "white", height: "100%" }}
                >
                  <div className="position-relative overflow-hidden">
                    <div className="signat">
                      <div className="gap"> &nbsp; </div>
                      <div className="gap"> &nbsp; </div>
                      <div className="gap"> &nbsp; </div>

                      {usersignature == "" && (
                        <>
                          <div className="addbutton">
                            <button
                              className={`nav-link add_Signature`}
                              type="button"
                              data-bs-toggle="offcanvas"
                              data-bs-target="#signpopup"
                              aria-controls="offcanvasRight"
                            >
                              Add Signature{" "}
                            </button>
                          </div>
                        </>
                      )}

                      {usersignature != "" && (
                        <>
                          <div className="signaturemain">{usersignature}</div>
                        </>
                      )}

                      <div className="sign_text">
                        {fname} {lname}{" "}
                      </div>
                      <div className="sign_text">{email}</div>

                      <div className="gap">
                        {" "}
                        <hr />{" "}
                      </div>

                      <div className="sign_text">
                        {EventData.cl_firstname} {EventData.cl_lastname}
                      </div>
                      <div className="sign_text">{EventData.cl_email}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Add Page Right Area */}

          <div className="col-lg-4">
            <div className="create-contract proposal_right_side">
              <span className="placeholder col-6"></span>
              <div className="row">
                <div className="col-12">
                  <div className="right-side-area">
                    <div
                      className="nav flex-column nav-pills me-3"
                      id="v-pills-tab"
                      role="tablist"
                      aria-orientation="vertical"
                    >
                      {proposalpages.map((addedpages, pageindex) => (
                        <>
                          <button
                            key={pageindex}
                            className={`nav-link ${
                              pageindex === 0 ? "active" : ""
                            }`}
                            id={`tab${pageindex}`}
                            data-bs-toggle="pill"
                            data-bs-target={`#adpage${pageindex}`}
                            type="button"
                            role="tab"
                            aria-controls={pageindex}
                            aria-selected={pageindex === 0 ? "true" : "false"}
                          >
                            <div className="right-side-box">
                              <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                  <div
                                    className="icon-box active bg-white"
                                    role="button"
                                  >
                                    <div className="row gap-2 align-items-start m-2">
                                      <div className="col-12 skeleton-one"></div>
                                      <div className="col-12 skeleton-two"></div>
                                      <div className="col-12 skeleton-three"></div>
                                      <div className="col-12 skeleton-four"></div>
                                    </div>
                                  </div>
                                  <h5 className="box-title smallfont">
                                    {addedpages.name}
                                  </h5>
                                </div>
                                <div
                                  className="nav-item dropdown"
                                  id="top-user-nav"
                                >
                                  <div
                                    className="nav-link dropdown"
                                    data-bs-toggle="dropdown"
                                  >
                                    <div className="three-dot-btn">
                                      <button
                                        className="border-0 bg-transparent"
                                        type="button"
                                      >
                                        <i className="fa-solid fa-ellipsis-vertical"></i>
                                      </button>
                                    </div>
                                  </div>
                                  <div className="dropdown-menu shadow-sm border-0 py-4 px-4">
                                    <Link to="#">
                                      <div
                                        className="link-btn mb-4 rename-page-btn"
                                        data-tab={pageindex}
                                        onClick={() => renamepage(pageindex)}
                                      >
                                        <i
                                          className="fa fa-pencil"
                                          aria-hidden="true"
                                        ></i>
                                        <span>Rename</span>
                                      </div>
                                    </Link>
                                    <Link to="#">
                                      <div
                                        className="link-btn mb-4 duplicate-page-btn"
                                        data-tab={pageindex}
                                        onClick={() => handleclone(pageindex)}
                                      >
                                        <i className="fa-solid fa-clone"></i>
                                        <span>Duplicate</span>
                                      </div>
                                    </Link>
                                    <Link to="#">
                                      <div
                                        className="link-btn text-danger delete-page-btn"
                                        data-tab={pageindex}
                                        onClick={() => handleClick(pageindex)}
                                      >
                                        <i className="fa-solid fa-trash"></i>
                                        <span>Delete</span>
                                      </div>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </button>
                        </>
                      ))}

                      {proposalstabs.map((tab, indexpro) => (
                        <>
                          {tab.type == "contract" && (
                            <>
                              {tab.pages.map((tabpages, contractpageindex) => (
                                <>
                                  <button
                                    key={contractpageindex}
                                    className={`nav-link ${
                                      tab.id === "v-pills-home" ? "active" : ""
                                    }`}
                                    id={`tab${contractpageindex}`}
                                    data-bs-toggle="pill"
                                    data-bs-target={`#cpage${contractpageindex}`}
                                    type="button"
                                    role="tab"
                                    aria-controls={tab.id}
                                    aria-selected={
                                      tab.id === "v-pills-home"
                                        ? "true"
                                        : "false"
                                    }
                                  >
                                    <div className="right-side-box">
                                      <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                          <div
                                            className="icon-box active bg-white"
                                            role="button"
                                          >
                                            <div className="row gap-2 align-items-start m-2">
                                              <div className="col-12 skeleton-one"></div>
                                              <div className="col-12 skeleton-two"></div>
                                              <div className="col-12 skeleton-three"></div>
                                              <div className="col-12 skeleton-four"></div>
                                            </div>
                                          </div>
                                          <h5 className="box-title smallfont">
                                            {tabpages.page_name}
                                          </h5>
                                        </div>
                                        <div
                                          className="nav-item dropdown"
                                          id="top-user-nav"
                                        >
                                          {contractpageindex == 0 ? (
                                            <>
                                              <div
                                                className="nav-link dropdown"
                                                data-bs-toggle="dropdown"
                                              >
                                                <div className="three-dot-btn">
                                                  <button
                                                    className="border-0 bg-transparent"
                                                    type="button"
                                                  >
                                                    <i className="fa-solid fa-ellipsis-vertical"></i>
                                                  </button>
                                                </div>
                                              </div>

                                              <div className="dropdown-menu shadow-sm border-0 py-4 px-4">
                                                <Link to="#">
                                                  <div
                                                    className="link-btn text-danger delete-page-btn"
                                                    data-tab={tab.id}
                                                    onClick={() =>
                                                      handleClick2(indexpro)
                                                    }
                                                  >
                                                    <i className="fa-solid fa-trash"></i>
                                                    <span>Delete</span>
                                                  </div>
                                                </Link>
                                              </div>
                                            </>
                                          ) : (
                                            <></>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </button>
                                </>
                              ))}

                              <button
                                key="signkey"
                                className="nav-link"
                                id={`sign-tab`}
                                data-bs-toggle="pill"
                                data-bs-target={`#sign`}
                                type="button"
                                role="tab"
                                aria-selected="false"
                              >
                                <div className="right-side-box">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                      <div
                                        className="icon-box active bg-white"
                                        role="button"
                                      >
                                        <div className="row gap-2 align-items-start m-2">
                                          <div className="col-12 skeleton-one"></div>
                                          <div className="col-12 skeleton-two"></div>
                                          <div className="col-12 skeleton-three"></div>
                                          <div className="col-12 skeleton-four"></div>
                                        </div>
                                      </div>
                                      <h5 className="box-title">Sign</h5>
                                    </div>
                                    <div
                                      className="nav-item dropdown"
                                      id="top-user-nav"
                                    >
                                      <div
                                        className="nav-link dropdown"
                                        data-bs-toggle="dropdown"
                                      >
                                        <div className="three-dot-btn">
                                          <button
                                            className="border-0 bg-transparent"
                                            type="button"
                                          >
                                            <i className="fa-solid fa-ellipsis-vertical"></i>
                                          </button>
                                        </div>
                                      </div>
                                      <div className="dropdown-menu shadow-sm border-0 py-4 px-4"></div>
                                    </div>
                                  </div>
                                </div>
                              </button>
                            </>
                          )}

                          {tab.type == "invoice" && (
                            <>
                              <button
                                key={tab.id}
                                className={`nav-link ${
                                  tab.id === "v-pills-home" ? "active" : ""
                                }`}
                                id={`${indexpro}-tab`}
                                data-bs-toggle="pill"
                                data-bs-target={`#tab${indexpro}`}
                                type="button"
                                role="tab"
                                aria-controls={tab.id}
                                aria-selected={
                                  tab.id === "v-pills-home" ? "true" : "false"
                                }
                                onClick={expandtextbox}
                              >
                                <div className="right-side-box">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                      <div
                                        className="icon-box active bg-white"
                                        role="button"
                                      >
                                        <div className="row gap-2 align-items-start m-2">
                                          <div className="col-12 skeleton-one"></div>
                                          <div className="col-12 skeleton-two"></div>
                                          <div className="col-12 skeleton-three"></div>
                                          <div className="col-12 skeleton-four"></div>
                                        </div>
                                      </div>
                                      <h5 className="box-title smallfont">
                                        {tab.title}
                                      </h5>
                                    </div>
                                    <div
                                      className="nav-item dropdown"
                                      id="top-user-nav"
                                    >
                                      <div
                                        className="nav-link dropdown"
                                        data-bs-toggle="dropdown"
                                      >
                                        <div className="three-dot-btn">
                                          <button
                                            className="border-0 bg-transparent"
                                            type="button"
                                          >
                                            <i className="fa-solid fa-ellipsis-vertical"></i>
                                          </button>
                                        </div>
                                      </div>

                                      <div className="dropdown-menu shadow-sm border-0 py-4 px-4">
                                        <Link to="#">
                                          <div
                                            className="link-btn text-danger delete-page-btn"
                                            data-tab={tab.id}
                                            onClick={() =>
                                              handleClick2(indexpro)
                                            }
                                          >
                                            <i className="fa-solid fa-trash"></i>
                                            <span>Delete</span>
                                          </div>
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </button>

                              {tab.pages.map(
                                (tabpages, invoicepageindextab) => (
                                  <>
                                    <button
                                      key={invoicepageindextab}
                                      className={`nav-link ${
                                        tab.id === "v-pills-home"
                                          ? "active"
                                          : ""
                                      }`}
                                      id={`${tab.id}-tab`}
                                      data-bs-toggle="pill"
                                      data-bs-target={`#invoicepage${invoicepageindextab}`}
                                      type="button"
                                      role="tab"
                                      aria-controls={tab.id}
                                      aria-selected={
                                        tab.id === "v-pills-home"
                                          ? "true"
                                          : "false"
                                      }
                                    >
                                      <div className="right-side-box">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <div className="d-flex align-items-center">
                                            <div
                                              className="icon-box active bg-white"
                                              role="button"
                                            >
                                              <div className="row gap-2 align-items-start m-2">
                                                <div className="col-12 skeleton-one"></div>
                                                <div className="col-12 skeleton-two"></div>
                                                <div className="col-12 skeleton-three"></div>
                                                <div className="col-12 skeleton-four"></div>
                                              </div>
                                            </div>
                                            <h5 className="box-title smallfont">
                                              {tabpages.page_name}
                                            </h5>
                                          </div>
                                          <div
                                            className="nav-item dropdown"
                                            id="top-user-nav"
                                          ></div>
                                        </div>
                                      </div>
                                    </button>
                                  </>
                                )
                              )}

                              {/* Current Page begin: Pay Box */}

                              <button
                                className="nav-link"
                                id="v-pills-profile-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#v-pills-profile"
                                type="button"
                                role="tab"
                                aria-controls="v-pills-profile"
                                aria-selected="false"
                              >
                                {/* Current Page: Pay Box */}
                                <div className="right-side-box">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                      <div
                                        className="icon-box active bg-white"
                                        role="button"
                                      >
                                        {/* Skeletons */}
                                        <div className="row gap-2 align-items-start m-2">
                                          <div className="col-12 skeleton-one"></div>
                                          <div className="col-12 skeleton-two"></div>
                                          <div className="col-12 skeleton-three"></div>
                                          <div className="col-12 skeleton-four"></div>
                                        </div>
                                      </div>
                                      <h5 className="box-title">Pay</h5>
                                    </div>
                                    {/* Dropdown */}
                                    <div
                                      className="nav-item dropdown"
                                      id="top-user-nav"
                                    >
                                      {/* Dropdown Menu */}
                                      <div className="dropdown-menu shadow-sm border-0 py-4 px-4">
                                        <Link to="#">
                                          <div className="link-btn mb-4">
                                            <i
                                              className="fa fa-pencil"
                                              aria-hidden="true"
                                            ></i>
                                            <span>Rename</span>
                                          </div>
                                        </Link>
                                        <Link to="#">
                                          <div className="link-btn text-danger">
                                            <i className="fa-solid fa-trash"></i>
                                            <span>Delete</span>
                                          </div>
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </button>
                            </>
                          )}

                          {tab.type == "questionnaires" && (
                            <>
                              <button
                                key={tab.id}
                                className={`nav-link ${
                                  tab.id === "v-pills-home" ? "active" : ""
                                }`}
                                id={`${indexpro}-tab`}
                                data-bs-toggle="pill"
                                data-bs-target={`#tab${indexpro}`}
                                type="button"
                                role="tab"
                                aria-controls={tab.id}
                                aria-selected={
                                  tab.id === "v-pills-home" ? "true" : "false"
                                }
                              >
                                <div className="right-side-box">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                      <div
                                        className="icon-box active bg-white"
                                        role="button"
                                      >
                                        <div className="row gap-2 align-items-start m-2">
                                          <div className="col-12 skeleton-one"></div>
                                          <div className="col-12 skeleton-two"></div>
                                          <div className="col-12 skeleton-three"></div>
                                          <div className="col-12 skeleton-four"></div>
                                        </div>
                                      </div>
                                      <h5 className="box-title smallfont">
                                        {tab.title}
                                      </h5>
                                    </div>
                                    <div
                                      className="nav-item dropdown"
                                      id="top-user-nav"
                                    >
                                      <div
                                        className="nav-link dropdown"
                                        data-bs-toggle="dropdown"
                                      >
                                        <div className="three-dot-btn">
                                          <button
                                            className="border-0 bg-transparent"
                                            type="button"
                                          >
                                            <i className="fa-solid fa-ellipsis-vertical"></i>
                                          </button>
                                        </div>
                                      </div>

                                      <div className="dropdown-menu shadow-sm border-0 py-4 px-4">
                                        <Link to="#">
                                          <div
                                            className="link-btn text-danger delete-page-btn"
                                            data-tab={tab.id}
                                            onClick={() =>
                                              handleClick2(indexpro)
                                            }
                                          >
                                            <i className="fa-solid fa-trash"></i>
                                            <span>Delete</span>
                                          </div>
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </button>
                            </>
                          )}
                        </>
                      ))}

                      {/* Add Page Start: New Page */}

                      <button
                        className="nav-link"
                        id="v-pills-profile-tab"
                        onClick={handleAddPage}
                      >
                        {/* Add Page: New Page */}
                        <div className="right-side-box">
                          <div className="d-flex align-items-center justify-content-between">
                            <div
                              aria-controls="offcanvasRight2"
                              className="d-flex align-items-center"
                            >
                              <div
                                className="icon-box icon-box-add-page"
                                role="button"
                              >
                                <span>
                                  <i className="fa-solid fa-plus"></i>
                                </span>
                              </div>
                              Add
                            </div>
                            {/* Dropdown */}
                            <div
                              className="nav-item dropdown"
                              id="top-user-nav"
                              aria-disabled="true"
                            >
                              <div
                                href="#"
                                className="nav-link dropdown"
                                data-bs-toggle="dropdown"
                              ></div>
                            </div>
                          </div>
                        </div>
                      </button>

                      {/* Add Page End: New Page */}

                      <div className="text-center pt-2">
                        <button
                          id="submit-btn"
                          type="button"
                          className="px-5 rounded-pill btn btn-primary btn-lg text-uppercase"
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal2"
                        >
                          Share
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/*  start of the sign   */}

              <div
                className="offcanvas offcanvas-end"
                tabindex="-1"
                id="signpopup"
                aria-labelledby="offcanvasRightLabel"
                data-bs-backdrop="false"
              >
                <div className="w-100 text-start header">
                  <button
                    type="button"
                    className="btn-close mt-3 ms-4 text-black"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  ></button>

                  <div className="text-center py-3">
                    <h5>Signature</h5>
                    <span style={{ color: "#727272" }}>Add Your Signature</span>
                  </div>
                </div>

                <div className="offcanvas-body p-0">
                  <div className="single_box mt-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <input
                          type="text"
                          className="signbox"
                          onChange={handleChange}
                          value={signaturebox}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="single_box mt-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <input
                          type="checkbox"
                          onChange={handleCheckboxChange}
                        />{" "}
                        By clicking the button below, I,{" "}
                        <b>
                          {fname} {lname}{" "}
                        </b>
                        , confirm and consent to the use of my electronic
                        signature to sign this document. I acknowledge that my
                        electronic signature is legally binding, just as if I
                        had signed the document in person
                      </div>
                    </div>
                  </div>

                  <div className="single_box mt-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <button
                          type="button"
                          className="mt-3 ms-4 text-black backbackground add_Signature"
                          data-bs-dismiss="offcanvas"
                          disabled={!isChecked}
                          onClick={addsignature}
                          aria-label="Close"
                        >
                          SIGN
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* end of the sign */}

              <div
                className={`offcanvas offcanvas-end ${
                  showSideCanvas ? "show" : ""
                }`}
                tabIndex="-1"
                id="offcanvasRight"
                data-bs-scroll="true"
                aria-labelledby="offcanvasRightLabel"
                data-bs-backdrop="false"
              >
                <div className="w-100 text-start header">
                  <button
                    type="button"
                    className="btn-close mt-3 ms-4 text-black"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                    onClick={handleClose}
                  ></button>

                  <div className="text-center py-3 proposal-header">
                    <h5>Add Page</h5>
                    <span style={{ color: "#727272" }}>
                      Select from the list below
                    </span>
                  </div>
                </div>
                {pageaddstatus ? (
                  <div
                    className="w-100 text-start header proposal-header"
                    onClick={addpage}
                  >
                    <div className="text-center py-3">
                      <span>+ Page With Text Only</span>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <div className="offcanvas-body p-0">
                  {openlist == "" && (
                    <>
                      <div className="single_box mt-3">
                        {contractadded == false && (
                          <>
                            <div
                              className="d-flex align-items-center justify-content-between"
                              onClick={() => setOpenlist("Contracts")}
                            >
                              <div>
                                <h5 className="px-4 py-2">
                                  Contracts Templates
                                </h5>
                              </div>
                              <div className="icon">
                                <i className="fa fa-chevron-right"></i>
                              </div>
                            </div>
                          </>
                        )}
                      </div>

                      <div className="single_box mt-4">
                        {invoiceadded == false && (
                          <>
                            <div
                              className="d-flex align-items-center justify-content-between"
                              onClick={() => setOpenlist("Invoice")}
                            >
                              <div>
                                <h5 className="px-4 py-2">Invoice Templates</h5>
                                <div className="d-flex align-items-center mt-1"></div>
                              </div>
                              <div className="icon">
                                <i className="fa fa-chevron-right"></i>
                              </div>
                            </div>
                          </>
                        )}
                      </div>

                      <div className="single_box mt-4">
                        <div
                          className="d-flex align-items-center justify-content-between"
                          onClick={() => setOpenlist("Questionnaire")}
                        >
                          <div>
                            <h5 className="px-4 py-2">
                              Questionnaire Templates
                            </h5>
                            <div className="d-flex align-items-center mt-1"></div>
                          </div>
                          <div className="icon">
                            <i className="fa fa-chevron-right"></i>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {/* template list start  */}

                  {openlist == "Contracts" && (
                    <div>
                      <h5 className="py-4 px-4">Contracts</h5>

                      {contracts.map((contract, indexcontract) => (
                        <div className="single_box mt-4" key={indexcontract}>
                          <div
                            className="d-flex align-items-center justify-content-between"
                            onClick={() => addcontracttoproposal(indexcontract)}
                          >
                            <div>
                              <h6>{contract.title}</h6>
                              <div className="d-flex align-items-center mt-1">
                                <i className="far fa-folder"></i>
                                <span className="ms-2">Contract</span>
                              </div>
                            </div>
                            <div className="icon">
                              <i className="fa fa-chevron-right"></i>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {openlist == "Invoice" && (
                    <div>
                      <h5 className="py-4 px-4">Invoice</h5>

                      {invoices.map((invoice, indexinvoice) => (
                        <div className="single_box mt-4" key={indexinvoice}>
                          <div
                            className="d-flex align-items-center justify-content-between"
                            onClick={() => addinvoicetoproposal(indexinvoice)}
                          >
                            <div>
                              <h6>{invoice.title}</h6>
                              <div className="d-flex align-items-center mt-1">
                                <i className="far fa-folder"></i>
                                <span className="ms-2">Invoice</span>
                              </div>
                            </div>
                            <div className="icon">
                              <i className="fa fa-chevron-right"></i>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {openlist == "Questionnaire" && (
                    <>
                      <div>
                        <h5 className="py-4 px-4">Questionnaire</h5>
                        {questionnaires.map((questionnaires, indexquest) => (
                          <div className="single_box mt-4" key={indexquest}>
                            <div
                              className="d-flex align-items-center justify-content-between"
                              onClick={() =>
                                addquestionnairestoproposal(indexquest)
                              }
                            >
                              <div>
                                <h6>{questionnaires.title}</h6>
                                <div className="d-flex align-items-center mt-1">
                                  <i className="far fa-folder"></i>
                                  <span className="ms-2">Questionnaire</span>
                                </div>
                              </div>
                              <div className="icon">
                                <i className="fa fa-chevron-right"></i>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});
